module.exports = __webpack_public_path__ + "static/media/consulting-service-img.0165a977.png";